export default function changeActiveSlider(id) {
  return {
    type: "CHANGE_ACTIVE_SLIDER",
    id,
  };
}
